/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import BusinessUnitSelectionModal from 'common/components/businessUnit/BusinessUnitSelectionModal';
import UnsetSelectedBusinessUnit from './UnsetSelectedBusinessUnit';

import { personnelBUsSelector } from 'common/redux/selectors/intl';
import { getSelectedBUId } from 'common/redux/selectors/appPreferences';
import { IntlActions } from 'common/redux/actions/intl';

import usePersonnel from 'common/hooks/usePersonnel';
import useClientId from 'common/hooks/useClientId';

type Props = { children: React.Node };

const BusinessUnitSelector = ({ children }: Props): React.Node => {
    const match = useRouteMatch();
    const clientId = useClientId();
    const personnel = usePersonnel();
    const dispatch = useDispatch();

    const businessUnits = useSelector(state =>
        personnelBUsSelector(state, { match })
    );

    const selectedBUId = useSelector(state =>
        getSelectedBUId(state, { match })
    );

    const isSelectedBUIdValid = React.useMemo(() => {
        if (!selectedBUId) {
            return true;
        }
        return Boolean(
            businessUnits.find(bu => bu.businessUnitId === selectedBUId)
        );
    }, [selectedBUId, businessUnits]);

    const setSelectedBU = id => {
        dispatch(
            IntlActions.setSelectedBU({
                clientId,
                personnelId: personnel.personnelId,
                selectedBU: id
            })
        );
    };

    if (selectedBUId && !isSelectedBUIdValid) {
        return <UnsetSelectedBusinessUnit />;
    }

    if (!selectedBUId && businessUnits.size > 0) {
        return (
            <BusinessUnitSelectionModal
                showDialog
                businessUnits={businessUnits}
                personnelName={personnel.name}
                onBusinessUnitSelect={id => {
                    setSelectedBU(id);
                }}
            />
        );
    }

    // NOTE: remount app - to clean previous state related to last selected bu
    return (
        <React.Fragment key={selectedBUId ?? 'not-set'}>
            {children}
        </React.Fragment>
    );
};

export default BusinessUnitSelector;
